import styles from "./Styles/Input.module.css"

function Input(props) {
    return <div style={{marginBottom:props.mb,marginTop:props.marginTop}} className={styles.input}>
        {props.label && <label style={{...props.labelStyle}}>{props.label}</label>}
        {props.rightIcon && <div onClick={props.onClickRightHandler} className={styles.rightIcon}>
            {props.rightIcon}
            </div>}
        <input style={{width:props.width || '100%', borderColor: props.error ? '#FF725E' : (props.white ? '#D6D6D6' : '#F1F3F6'),marginTop:props.label ? 14 : 0,backgroundColor:props.white ? '#fff' : '#F1F3F6'}} {...props} />
    </div>
}

export default Input